import { setOpenLocationSelectionModal } from '@/store/modal';
import { openSearchModal, SearchModalOpenContext } from '@/store/search/search.store';
import { PersistedUserNavigationSearchParams } from '@/types/enums/persisted-user-navigation-search-params.enum';

interface HandleOpenSearchModalProps extends SearchModalOpenContext {
  searchTerm?: string | undefined;
  skipLocationModal?: boolean;
}

export function handleOpenSearchModal({
  searchTerm,
  skipLocationModal,
  origin,
  originCategory,
}: HandleOpenSearchModalProps = {}) {
  const searchParams = new URLSearchParams(window.location.search);
  const city = searchParams.get(PersistedUserNavigationSearchParams.CIDADE);

  if (city || skipLocationModal) {
    openSearchModal(true, searchTerm, { origin, originCategory, term: searchTerm });
  } else {
    if (searchTerm) {
      setOpenLocationSelectionModal(true, {
        shouldOpenSearchModal: false,
        pendingSearchTerm: searchTerm,
        pendingSearchContext: { origin, originCategory, term: searchTerm },
      });
    } else {
      setOpenLocationSelectionModal(true, {
        shouldOpenSearchModal: false,
        pendingSearchContext: { origin, originCategory },
      });
    }
  }
}
